import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import StaticGrid from "@common/components/grid/staticGrid.component";
import responderExigenciaSelector from "../store/responderExigencia.selectors";
import responderExigenciaActions from "../store/responderExigencia.actions";
import autoBind from "react-autobind";
import ModalDocumento from "../container/responderExigencia.documento.modal";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.ResponderExigencia.Documento",
      applySearchOnLoad: true,
      isNotCheckable: true
    };

    const columns = [
      {
        fieldName: "Descrição Arquivo",
        dataName: "DescricaoArquivo",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Arquivo",
        dataName: "Arquivo",
        show: true,
        type: "text",
        removeFilter: true
      },
    ];

    const actions = [
      {
        type: 'delete',
        onClick: async dataItem => {
          const result = await _alert.confirm('Deseja realmente remover o documento anexado?', 'Remover Documento Anexado Selecionado');
          if (result) this.props.responderExigenciaActions.removerDocumentoExigencia(dataItem);
        },
      },
    ];

    const order = [
      { fieldName: "Descrição Arquivo", dataName: "Arquivo", order: "A" },
    ]

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      },
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  render() {
    const { responderExigencia } = this.props.responderExigenciaSelector;
    const { FormExigencia } = responderExigencia;
    const { DataGridDocumento } = FormExigencia;

    return (
      <Fragment>
        <ModalDocumento />
        <StaticGrid {...this.config} itens={DataGridDocumento.asMutable()}></StaticGrid>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    responderExigenciaActions
  },
  selectors: {
    responderExigenciaSelector
  }
})(Container);

